import { ConfirmModal } from '@affine/component';
import type { ComponentProps } from 'react';

export type ObjectPermissionDialogShellProps = ComponentProps<
  typeof ConfirmModal
>;

/** Shared modal chrome for document/folder create and configuration flows. */
export const ObjectPermissionDialogShell = (
  props: ObjectPermissionDialogShellProps
) => <ConfirmModal {...props} />;
